import { KitDeletionArea } from "@/components/KitDeletionArea";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { ExportKitArea } from "@/components/kit/ExportKitArea";
import { KitDebugPageLink } from "@/components/kit/KitDebugPageLink";
import { useKitData } from "@/data/use-kits-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export const ConversationSettingsPage = () => {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();

  const { kit, updateKit } = useKitData(groupUuid, kitUuid);

  if (!kit) {
    return null;
  }

  return (
    <Page>
      <PageHeader>
        <PageHeader.Title>Chat Settings</PageHeader.Title>
      </PageHeader>
      <PageBody innerClassName="gap-8">
        <DisplayEditor
          name={kit.name}
          description={kit.description}
          onNameChange={(name) => updateKit({ name })}
          onDescriptionChange={(description) => updateKit({ description })}
        />
        <ExportKitArea kit={kit} />
        <KitDeletionArea kit={kit} />
        <KitDebugPageLink />
      </PageBody>
    </Page>
  );
};
